<template>
  <div class="gs-app gs-refresh-controls w-full gv-integration-event">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
      <div class="flex flex-col gv-integration-event__panel">
      <label class="font-semibold text-sm text-grey-700 mb-1 text-left">
        {{$t('frontend_groovevideo_videos_step3_select_event')}}
      </label>
      <div class="flex flex-row text-sm gv-integration-event__controls">
        <gd-dropdown
          :options="eventTypes"
          v-model="selectedEvent"
          class="text-left w-full mb-4"
          size="full"
          :placeholder="$t('frontend_groovevideo_videos_step3_select_event_placeholder')"
          @change="setEvent($event)"
        ></gd-dropdown>
        <gs-button
          v-if="selectedEvent && selectedEvent.includes('watchedUntil_')"
          size="icon"
          variant="ghost"
          class="is-destructive ml-4"
          aria-label="Delete watched-until event"
          @click="deleteWatchedUntil(selectedEvent)"
        >
          <i class="fas fa-trash" />
        </gs-button>
      </div>
    <watched-until v-if="selectedEvent === 'watchedUntil'" :video="model" :minutes="minutes" :integration_type="'other'" @addWatchedUntilPoint="addWatchedUntilPoint" ref="watchedUntil" :optinId="optinId" />
    </div>
    <div v-show="selectedEvent === 'registration'">
      <add-integration
        ref="registeredTab"
        class="w-full"
        :model="model"
        :integrations="integrations"
        :selectedIntegrations="selectedIntegration.registration ? selectedIntegration.registration : []"
        :resources-path="resourcesPath"
        :server-path="serverPath"
        :optinId="optinId"
        :plugin-site-data="pluginSiteData"
        :eventId="1"
        :eventType="'static'"
        v-if="dataLoaded"
      ></add-integration>
    </div>
    <div v-show="selectedEvent === 'completed'">
      <add-integration
        ref="completedTab"
        class="w-full"
        :model="model"
        :integrations="integrations"
        :selectedIntegrations="selectedIntegration.completed ? selectedIntegration.completed : []"
        :resources-path="resourcesPath"
        :server-path="serverPath"
        :plugin-site-data="pluginSiteData"
        :optinId="optinId"
        :eventId="2"
        :eventType="'static'"
        v-if="dataLoaded"
      ></add-integration>
    </div>
    <div v-if="watchedUntilPoints.length > 0">
      <div v-for="watchedUntilPoint in watchedUntilPoints" v-bind:key="'watchedUntil_'+watchedUntilPoint.id" v-show="selectedEvent === ('watchedUntil_'+watchedUntilPoint.id)">
        <add-integration
          :ref="`watchedUntil_${watchedUntilPoint.id}`"
          class="w-full"
          :model="model"
          :integrations="integrations"
          :selectedIntegrations="watchedUntilSelectedIntegrations(watchedUntilPoint.id)"
          :resources-path="resourcesPath"
          :server-path="serverPath"
          :plugin-site-data="pluginSiteData"
          :eventId="watchedUntilPoint.id"
          :optinId="optinId"
          :eventType="'dynamic'"
          v-if="dataLoaded"
        ></add-integration>
      </div>
    </div>
  </div>
</template>
<style>
.placeholder .vue-treeselect__single-value{
    --tw-text-opacity: 1;
    color: rgba(220, 220, 234, var(--tw-text-opacity));
}
</style>
<script>

import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DropdownWithScroll from '@/components/DropdownWithScroll';
import watchedUntil from './watchedUntil';
import addIntegration from './addOtherIntegration';
import auth from '@groovepages/gd-lib/auth';
import Swal from 'sweetalert2';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

  props: {
    model: {
      required: true,
    },
    optinId: {},
    event: {
      required: true
    },
    watchedUntil: {
      default() {
        return [];
      },
    },
    minutes: {
      required: true
    }
  },

  components: {
    Loading,
    watchedUntil,
    DropdownWithScroll,
    addIntegration,
    Treeselect,
  },
  data() {
    return {
      loaderColor: themeConfig.appPrimaryColor,
      isLoading: false,
      fullPageLoader: true,
      selectedEvent: this.event,
      selectedIntegration: [],
      watchedUntilPoints: [],
      video: {},
      dataLoaded: false,
      eventTypes: [
        {
          text: this.$t('frontend_groovewebinar_registered_in_webinar'),
          value: 'registration',
        },
        {
          text: this.$t('frontend_groovewebinar_completed_webinar'),
          value: 'completed',
        },
        {
          text: this.$t('frontend_groovevideo_videos_step3_watched_until'),
          value: 'watchedUntil',
        },
      ],
    };
  },

  computed: {
    resourcesPath() {
      return `${window.gdEnv.VUE_APP_STORAGE_URL}/plugins/`;
    },

    serverPath() {
      return `${window.gdEnv.VUE_APP_API_URL}/groovedigital/plugins/call/`;
    },

    pluginSiteData() {
      return this.$store.getters.pluginSiteSettings;
    },
  },
  
  async created() {
    this.showLoader();
    
    this.video = this.model;

    //Get watched until events
    this.watchedUntilPoints = this.watchedUntil.map(el => {
      if(el.integration_type == 'other' && el.optin_id == this.optinId){
        this.addWatchedUntilPoint(el, false);
        return el;
      }
    }).filter(x => x);
    //Get all integrations
    this.integrations = this.availableIntegrations();

    //Get selected integrations
    this.selectedOtherIntegrations = await this.video.otherIntegration().$get();
    this.selectedIntegration = [];
    
    this.selectedOtherIntegrations.forEach((integration) => {
      if(integration.event && integration.optin_id == this.optinId){
        if(!this.selectedIntegration[integration.event.slug]){
          this.selectedIntegration[integration.event.slug] = [];
        } 
        this.selectedIntegration[integration.event.slug].push(integration);
      }
    });
    this.dataLoaded = 1;
    this.hideLoader();
  },
  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    addWatchedUntilPoint(element, newElement = true){
      let minutes = element.minutes;
      if(newElement){
        this.watchedUntilPoints.push(element);
      }
      this.eventTypes.push({
        text: this.$t('frontend_groovewebinar_watched_until_webinar', {minutes}),
        value: 'watchedUntil_'+element.id,
      });
      if(newElement) {
        this.selectedEvent = 'watchedUntil_'+element.id;
      }
    },
    setEvent(event) {},
    watchedUntilSelectedIntegrations(id){
      return this.selectedIntegration['watchedUntil_' + id] ? this.selectedIntegration['watchedUntil_' + id] : [];
    },
    async deleteWatchedUntil(selection){
      const id = selection.substring(selection.indexOf('_') + 1);
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_non_revertable'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_delete_confirm'),
      });
      
      if(accept) {
        const watchedUntil = await this.video.watchedUntilEvent().$find(id);
        console.log(watchedUntil);
        const response = await watchedUntil.for(this.video).delete();
        if (typeof response.data !== 'undefined' &&
          typeof response.data.status !== 'undefined' &&
          response.data.status == true)
        {
          let tabIndex = this.eventTypes.findIndex(el => el.value == 'watchedUntil_'+id);
          this.eventTypes.splice(tabIndex,1);
          const deletedWatchedUntil = this.watchedUntilPoints
              .map((item) => item.id)
              .indexOf(id);
          this.watchedUntilPoints.splice(deletedWatchedUntil, 1);
          this.selectedEvent = null;
        }
      }
    },
    async saveIntegration() {
      this.showLoader();
      // #TODO
      if (this.$refs.registeredTab && this.selectedEvent === 'registration') {
        const response = await this.$refs.registeredTab.save(
          'registration'
        );
      } else if (
        this.$refs.completedTab &&
        this.selectedEvent === 'completed'
      ) {
        const response = await this.$refs.completedTab.save(
          'completed'
        );
      } else {
        //Dynamic tab
        let tabIndex = this.selectedEvent.search('watchedUntil_');
        if(tabIndex != -1){
          let tabArr = this.selectedEvent.split("_");
          let watchedUntilId = tabArr[1];
          const response = await this.$refs[this.selectedEvent].save('watchedUntil', watchedUntilId);  
        }
      }
      this.hideLoader();
      return this.localModel;
    },
    availableIntegrations() {
      const user = auth.authenticatedUser();
      if (user.metadata && user.metadata.integrations) {
        const integrations = [];
        user.metadata.integrations.map((value, key) => {
          const integrationId = value.id;
          const integrationType = value.type.split('-')[0];
          const integrationPlugin = `${integrationType}-component`;
          if (
            integrations.findIndex((x) => x.value == integrationPlugin) == -1
          ) {
            integrations.push({
              id: integrationId,
              text:
                integrationType.charAt(0).toUpperCase() +
                integrationType.slice(1),
              value: integrationPlugin,
            });
          }
        });

        return integrations;
      }
      return [];
    },
  },
}
</script>

<style>
.gv-integration-event__panel { gap: 12px; padding: 20px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); }
.gv-integration-event__controls { align-items: flex-start; gap: 12px; }
@media (max-width: 640px) { .gv-integration-event__panel { padding: 16px; } .gv-integration-event__controls { flex-direction: column; } .gv-integration-event__controls > * { width: 100%; } .gv-integration-event__controls .ml-4 { margin-left: 0 !important; } }
</style>
